<template>
  <div class="flex flex-col gap-4">
    <div class="text-brown-800 font-inter">
      <div class="text-text-display-lg font-black tracking-[-0.03em]">Password created!</div>
      <div class="text-text-body-md font-semibold mt-[16px]">
        You’re all set! Head back to the login screen to get started ⚡️
      </div>
    </div>
    <BottomButton text="Back to Login" @click="redirectToLogin" class="my-[32px] w-full" />
  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';

export default {
  name: 'PasswordCreated',
  components: {
    BottomButton,
  },
  methods: {
    async redirectToLogin() {
      await this.$store.dispatch('registration/updateStep', 0);
      this.$router.push('/login');
    },
  },
};
</script>
